// Invalid-SEB-configuration error surface (R15b-b2f: ported native). Rendered
// by LockdownProvider when the lockdown config is invalid; must paint without
// network (offline-preloaded chunk kept by the provider). Native ErrorView +
// QuitButton — no antd, no v1 tree edge (survives b3's deletion).
import { CloseCircleLinear } from '@assessprep/icons/solar';
import { useTranslation } from 'react-i18next';

import { QuitButton } from '@/components/ap/lockdown/QuitButton';
import { ErrorView } from '@/components/ap/status/ErrorView';

export const LockdownConfigError = () => {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center">
      <ErrorView
        title={t('LockdownProvider.lockdown_configuration_error')}
        subTitle={t('LockdownProvider.invalid_configuration_detected')}
        showHomeButton={false}
        customExtra={
          <QuitButton
            key="seb-lockdown-error-quit"
            quitButtonIcon={<CloseCircleLinear aria-hidden />}
            quitButtonText={t('ViewCard.quit_app')}
          />
        }
      />
    </div>
  );
};

export default LockdownConfigError;
